// assets
import { IconDatabaseImport } from '@tabler/icons-react';

// constant
const icons = { IconDatabaseImport };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const bulk = {
    id: 'bulk',
    title: 'Bulk Operation',
    type: 'group',
    authority: 'BULK_VIEW',
    children: [
        {
            id: 'memberBulk',
            title: 'Member',
            type: 'item',
            url: '/bulk/member',
            icon: icons.IconDatabaseImport
        },
        {
            id: 'organizationBulk',
            title: 'Organization',
            type: 'item',
            url: '/bulk/organization',
            icon: icons.IconDatabaseImport
        }
    ]
};

export default bulk;
